import React, { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import ErrorBoundary from './components/ErrorBoundary.tsx';
import { HelmetProvider } from 'react-helmet-async';
import posthog from 'posthog-js';
import { POSTHOG_KEY, POSTHOG_HOST, APP_ENV } from './config/environment';

// Initialize PostHog
if (POSTHOG_KEY) {
  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    loaded: (ph) => {
      if (APP_ENV === 'development' || window.location.hostname === 'localhost') {
        ph.opt_out_capturing(); // Opt-out in development
        console.log('PostHog loaded (dev mode, opted out by default)');
      } else {
        ph.opt_in_capturing();
        console.log('PostHog loaded (analytics enabled)');
      }
    },
    // Autocapture is on by default, but you can configure it:
    autocapture: {
      // See PostHog docs for all options
      capture_copied_text: true, // Capture text copied to clipboard
    },
    // Enable session recording (check your PostHog plan for availability)
    session_recording: {
      // consoleLogRecordingEnabled: true, // Record console logs (be mindful of sensitive data)
      maskAllInputs: true, // Recommended for privacy
      // maskTextSelector: ".sensitive-text", // CSS selector for text to mask
    },
    // Opt-in to sending pageleave events (improves session duration accuracy)
    capture_pageleave: true,
    // For single-page apps (SPAs) like yours using React Router
    capture_pageview: true, // PostHog's default is true, this ensures it's explicitly set.
                            // For SPAs, PostHog automatically captures $pageview on URL changes.
  });
} else {
  console.warn('PostHog key is not set. Analytics will not be tracked.');
}


const rootElement = document.getElementById('root');
if (rootElement) {
  createRoot(rootElement).render(
    <StrictMode>
      <HelmetProvider>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
      </HelmetProvider>
    </StrictMode>,
  );
}
